var map = {
	"./10699-fireworks-button-animation.json": 266,
	"./12821-failed-attempt.json": 267,
	"./18304-kiss-of-the-heart.json": 80,
	"./23420-slot-machine.json": 268,
	"./37920-coins-drop.json": 269,
	"./38008-box-open-and-close-package-animation.json": 270,
	"./43714-scratch-card.json": 81,
	"./44487-presente.json": 271,
	"./47410-ace-of-spade.json": 272,
	"./4946-coin-firework.json": 82,
	"./51936-sad-tear.json": 83,
	"./57856-gift-animation.json": 44,
	"./9915-spinner-fail.json": 273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;